export enum AsyncTaskTypeType {
  CONNECTION_SYNC_EXTERNAL_LIST = 'Connection Sync',
  CONNECTION_UPDATE_OUR_DB = 'Connection Update',
  CRADLEPOINT_SYNC = 'Cradlepoint Sync',
  CRADLEPOINT_UPDATE = 'Cradlepoint Update',
  SIERRAWIRELESS_SYNC = 'SierraWireless Sync',
  SIERRAWIRELESS_UPDATE = 'SierraWireless Update',
  PEPWAVE_SYNC = 'Pepwave Sync',
  PEPWAVE_UPDATE = 'Pepwave Update',
  LEAX_SYNC = 'Leax Sync',
  LEAX_UPDATE = 'Leax Update',
  INHAND_SYNC = 'InHand Sync',
  INHAND_UPDATE = 'InHand Update',
  TEAL_PLANS_UPDATE = 'Teal Plans Update',
  TEAL_DATA_CONSUMPTIONS_UPDATE = 'Teal Data Consumptions Update',
  BATTERY_BULK_UPLOAD = 'Battery Bulk Upload',
  POWER_CYCLE_BULK_UPLOAD = 'PowerCycle Bulk Upload',
  PENDING_ROUTER_BULK_UPLOAD = 'Pending Router Bulk Upload',
  DIALER_BULK_UPLOAD = 'Dialer Bulk Upload',
  ATA_GS_BULK_UPLOAD = 'ATA GS Bulk Upload',
  ATA_ACS_BULK_UPLOAD = 'ATA ACS Bulk Upload',
  TC_SIM_BULK_UPLOAD = 'Sim Bulk Upload',
  ENCLOSURE_BULK_UPLOAD = 'Enclosure Bulk Upload',
  LOCATION_BULK_UPLOAD = 'Location Bulk Upload',
  USER_BULK_UPLOAD = 'User Bulk Upload',
  E911_PROVISIONING = 'e911 Provisioning',
  DELETE_E911_RECORD = 'Delete e911 Record',
  CONFIGURE_NEW_DID = 'Configure New Did',
  SETUP_XML_UPDATE = 'Update Setup XML',
  FULL_XML_UPDATE = 'Update Full XML',
  GDMS_SETUP_XML_UPDATE = 'Cloud Update Setup XML',
  SKYSWITCH_CREATE_PORT_REQUEST = 'Create Port Request',
  DID_BULK_UPLOAD = 'Did Bulk Upload',
  DID_BULK_ASSIGNMENT_CHANGE = 'DID Bulk Assignment Change',
  IMPORT_DEVICES_FROM_GDMS = 'Import Devices from GDMS',
  CELL_TOWER_ADDRESS_BULK_UPLOAD = 'Cell Tower Address Bulk Upload',
  CELL_TOWER_FILE_SYNC = 'Cell Tower File Sync',
  OKTA_USER_CREATION = 'Okta User Creation',
  OTHER = 'Other',
}
